// __demoBadges — TEMPORARY single source of truth for badge demo mode.
//
// Phase R7 follow-up (2026-05-14): the user wants to review the full
// badge UI in one screenshot before any of the underlying conditions
// actually trigger in production. Rather than scatter "force on" flags
// across a dozen files, every consumer imports DEMO_BADGES from here
// and falls back to its real condition when this flag is false.
//
// To EXIT demo mode after review: flip DEMO_BADGES to `false`. Every
// surface returns to its live signal in the same render cycle.
// To DELETE demo mode entirely: leave DEMO_BADGES = false (or remove
// this file and its imports). The fallback paths are written so the
// demo overrides are inert when the flag is off — no perf, no UI cost.

export const DEMO_BADGES = false;

// Fake values used ONLY when DEMO_BADGES is true. Tuned so every
// badge fires at a visible non-zero count and every emoji indicator
// has its triggering condition met.
export const DEMO_VALUES = {
  /** Direct sub-agents needing attention (warning/breach/suspended). */
  homeDefaulters: 3,
  /** Pending player payment requests. */
  playerPending:  5,
  /** Pending sub-agent payment requests. */
  agentPending:   2,
  /** Un-opted-in platform offers. */
  rewardsPending: 4,
  /** Forces 😨 scared-face: wallet hero + Profile tab + Wallet sub-tab. */
  walletBalance: -2450,
  /** Forces 😳 shamed-face: deposit hero + Profile tab + Deposit sub-tab. */
  depositBalance: 0,
} as const;
